module.exports = __webpack_public_path__ + "static/media/gradMedHum.1312eea6.webp";